import { uniqueId } from "lodash";
import { useLocation } from "../../hooks/useLocation";
import { ToursContext } from "./context";
import React from "react";
import { useTours } from "../../hooks/useTours";

export function ToursContextProvider({ children, data }) {

    const { request, agency, order_by_options: orderByOptions, sort_by: sortBy } = data


    const [loading, setLoading] = React.useState(false);


    const [page, setPage] = React.useState({
        formId: uniqueId(),
        request,
        agency,
        sortBy,
        orderByOptions,
        impressions: [],
        filterParams: {
            min_duration: !_.isEmpty(request.min_duration) ? (parseInt(request.min_duration)) : undefined,
            max_duration: !_.isEmpty(request.max_duration) ? (parseInt(request.max_duration)) : undefined,
            min_price: !_.isEmpty(request.min_price) ? (parseInt(request.min_price)) : undefined,
            max_price: !_.isEmpty(request.max_price) ? (parseInt(request.max_price)) : undefined,
            tourRating: !_.isEmpty(request.rating) ? (parseInt(request.rating)) : 0,
            tourCategories: !_.isEmpty(request.tour_category) ? request.tour_category : [],
        }
    });


    const toggleLoader = () => setLoading(!loading)
    const showLoader = () => setLoading(true)
    const hideLoader = () => setLoading(false)


    const location = useLocation(data);
    const tours = useTours(data);


    const value = {
        get context() {
            return data;
        },
        location,
        tours,
        page,
        showLoader,
        toggleLoader,
        hideLoader,
        handleFormSubmit: (formId) => {
            showLoader();
            const form = document.getElementById(formId);
            form.submit();
        },
        measureProductClick(product, position, event) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': "select_item",
                'ecommerce': {
                    'items': [{
                        'item_id': product.resmark_id,
                        'item_name': product.name,
                        'item_category': product.categories_string,
                        'price': product.price,
                        'location_id': location.get().id
                    }]
                }
            });

            dataLayer.push({
                'event': 'productClick',
                'ecommerce': {
                    'click': {
                        'actionField': { 'list': location.get().name },
                        'products': [{
                            'name': product.name,
                            'id': product.resmark_id,
                            'price': product.price,
                            'category': product.categories_string,
                            'position': position
                        }]
                    }
                }
            });
        },
        measureProductImpression(product, position) {
            let impressions = [...page.impressions];

            if (!_.includes(impressions, product.resmark_id)) {

                impressions.push(product.resmark_id);

                setPage({ ...page, impressions });

                // Google Analytics 4
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: [{
                            'item_id': product.resmark_id,
                            'item_name': product.name,
                            'item_category': product.categories_string,
                            'location_id': location.get().id,
                            'price': product.price,
                        }]
                    }
                });

                // Universal Analytics (old)
                dataLayer.push({
                    'event': 'productImpression',
                    'ecommerce': {
                        'currencyCode': 'USD',
                        'impressions': [
                            {
                                'name': product.name,
                                'id': product.resmark_id,
                                'price': product.price,
                                'category': product.categories_string,
                                'list': location.get().name,
                                'position': position
                            }]
                    }
                });
            }
        },
        changeDurationRange(form_id, slideEvent) {
            setPage({
                ...page,
                filterParams: {
                    ...page.filterParams,
                    min_duration: slideEvent.from,
                    max_duration: slideEvent.to,
                }

            });
        },
        changePriceRange(form_id, slideEvent) {
            setPage({
                ...page,
                filterParams: {
                    ...page.filterParams,
                    min_price: slideEvent.from,
                    max_price: slideEvent.to
                }
            })
        },
        changeRating(event) {
            setPage({
                ...page,
                filterParams: {
                    ...page.filterParams,
                    tourRating: event.target.value
                }
            })
        },

        changeTourCategories(event) {
            let { tourCategories } = page.filterParams
            let value = event.target.value;

            // Check if value is in the array
            if (tourCategories.indexOf(value) !== -1) {
                let i = tourCategories.indexOf(value)
                tourCategories.splice(i, 1)
            } else {
                tourCategories.push(value)
            }


            setPage({
                ...page,
                filterParams: {
                    ...page.filterParams,
                    tourCategories
                }
            });
        }
    }

    return (
        <ToursContext.Provider value={value} >{children}</ToursContext.Provider>
    )
}


// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/ToursContextProvider.jsx